import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
import { HERO_MOCKUP_URL } from '../utils/heroImage';
export function Hero() {
  return <section id="hero" className="w-full bg-[#F5F6F7] px-6 py-16 sm:px-10 lg:py-20" data-id="element-88" data-mp="9ip7ey33opts">
      <div className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-89" data-mp="4njq6ckn7zc1">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-90" data-mp="1285x3nzc5smb">
          <h1 className="font-heading text-4xl font-bold leading-tight text-[#287C65] sm:text-5xl" data-id="element-91" data-mp="sa9q98dflju0">
            ¿Cansada de sentirte hinchada y sin energía?
          </h1>

          <p className="mt-6 text-base text-[#374151] sm:text-xl" data-id="element-92" data-mp="3d1a9nnfemhev">
            Descubre el <span className="font-bold text-[#287C65]" data-id="element-93" data-mp="3cz5w0drpe41e">método antiinflamatorio</span> que transformó a
            miles de mujeres en 12 semanas.
          </p>
          <p className="mt-3 text-sm font-semibold text-[#374151] sm:text-base" data-id="element-94" data-mp="3j9u0yz9q1olt">
            245 recetas + 5 bonos + planificador anual — todo lo que necesitás para desinflamarte de verdad
          </p>
        </motion.div>

        {/* LCP element: no entrance animation, so it paints immediately instead of fading in with the rest of the hero. */}
        <img src={HERO_MOCKUP_URL} alt="Pack completo Barriga Plana: 6 tomos de recetas antiinflamatorias más 5 bonos" width={1024} height={1024} fetchPriority="high" loading="eager" decoding="sync" className="mt-8 h-auto w-full max-w-[360px] sm:max-w-[420px]" data-id="element-95" data-mp="30i19586e29fo" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.15,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex flex-col items-center" data-id="element-96" data-mp="2vjpvsngvxgsp">
          <a href="#comprar" onClick={trackInitiateCheckout} className="mt-8 inline-flex w-full items-center justify-center rounded-lg bg-coral px-8 py-4 text-lg font-bold text-white shadow-lg transition-colors duration-150 ease-out hover:bg-coral-dark sm:w-auto sm:min-w-[300px]" data-id="element-97" data-mp="s21gc6a6u3xc">
            Quiero el método antiinflamatorio
          </a>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-gray-600" data-id="element-98" data-mp="dbaoiy8lj4u8">
            <span className="flex items-center gap-1.5" data-id="element-99" data-mp="161t06nndyej9">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="162ccnou9oapw" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-101" data-mp="110wpnr8j3u4v">
              <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="x1w6u8q1wrhv" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-103" data-mp="3lt756pxsnptq">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="3lqm2jypo95ux" /> Pago seguro
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}